<template>
  <div id="app">
    <a class="skip-link" href="#main-content">跳到主要内容</a>
    <app-shell v-if="!$route.meta.noShell" />
    <div v-else id="main-content" class="bare-view"><router-view /></div>
    <global-audio-player />
  </div>
</template>

<script>
import AppShell from '@/components/layout/AppShell.vue'
import GlobalAudioPlayer from '@/components/audio/GlobalAudioPlayer.vue'

export default {
  name: 'App',
  components: { AppShell, GlobalAudioPlayer }
}
</script>

<style lang="scss">
@import './assets/styles/common.scss';
</style>
